{
  "pt": {
    "todo_list": {
      "actions": {
        "add": "Criar lista de tarefas",
        "cancel": "Anular",
        "delete_todo_list": "Eliminar lista",
        "edit": "Editar lista de tarefas",
        "new": "Lista de tarefas",
        "save": "Guardar",
        "title": "Título da lista"
      },
      "attributes": {
        "name": "Título"
      },
      "labels": {
        "assignToLevel": "Atribuir ao nível",
        "createdAt": "Criado em",
        "filter_employee": "Responsável",
        "newTodoList": "Nova lista de tarefas",
        "sort": {
          "created_at_asc": "Oldest first",
          "created_at_desc": "Newest fist",
          "name_lower_asc": "Título A -> Z",
          "name_lower_desc": "Título Z -> A"
        }
      },
      "placeholders": {
        "employees": {
          "new": {
            "subtitle": "Mantenha uma visão geral do que você e a sua equipa têm de fazer.",
            "title": "Abrir uma nova lista de tarefas"
          }
        }
      },
      "toasts": {
        "create": "Lista de tarefas criada com sucesso",
        "delete": "A lista de tarefas foi eliminada com êxito",
        "update": "A lista de tarefas foi actualizada com êxito"
      },
      "validation": {
        "needTitle": "Título necessário"
      }
    }
  }
}
